<template>
  <transition
    name="ui-dropdown"
    @after-enter="allowClose = true"
    @before-leave="allowClose = false"
  >
    <div :class="classList" v-if="visible" v-click-outside="close">
      <div v-if="$slots.header">
        <slot name="header" />
      </div>
      <div
        :class="[
          'ui-dropdown-content',
        ]"
        ref="content"
      >
        <div :class="[
               'ui-dropdown-scrollview',
               { 'ui-dropdown-scrollable': contentScrollable }
             ]"
          ref="scrollview"
        >
          <slot :close="close" />
        </div>
        <div
          class="ui-dropdown-overlay"
          v-if="contentScrollable && overlayHeight"
          :style="{ transform: `translateY(${overlayOffset}px)`, height: `${overlayHeight}px` }"
        />
      </div>
      <div class="ui-dropdown-footer" v-if="$slots.footer">
        <slot name="footer" />
      </div>
    </div>
  </transition>
</template>

<script>
import { throttle } from 'throttle-debounce';

export default {
  name: 'UiDropdown',

  props: {
    text: {
      type: String,
      default: '',
    },
    visible: {
        type: Boolean,
        default: () => false,
    },
    overlayHeight: {
      type: [Number, String],
      default: 0,
    },
    wrapperClass: {
      type: [String, Array, Object],
      default: '',
    },
    left: {
      type: Boolean,
      default: () => false,
    },
    right: {
      type: Boolean,
      default: () => false,
    },
  },

  data: () => ({
    contentScrollable: false,
    overlayOffset: 1,
    allowClose: false,
  }),

  computed: {
    classList() {
      return [
        'ui-dropdown',
        { 'ui-dropdown-left': this.left },
        { 'ui-dropdown-right': this.right },
        ...this.wrapperClass,
      ];
    }
  },

  watch: {
    visible(visible) {
      if (visible) {
        this.$nextTick(() => {
          this.contentScrollable = this.$refs.scrollview.scrollHeight >= 420;
          if (this.contentScrollable) {
            this.initScrollListener();
          }
        });
      }
    },
  },

  beforeDestroy() {
    this?.$refs?.scrollview?.removeEventListener?.('scroll', this.onContentScroll);
  },

  methods: {
    close(e) {
      if (this.allowClose)
        this.$emit('on-close', e);
    },
    initScrollListener() {
      this.$refs.scrollview.addEventListener('scroll', this.onContentScroll);
    },
    onContentScroll: throttle(100, function() {
      const { scrollHeight, scrollTop, offsetHeight } = this.$refs.scrollview;
      const scrollRemaining = scrollHeight - scrollTop - offsetHeight;
      this.overlayOffset = scrollRemaining < this.overlayHeight
        ? this.overlayHeight - scrollRemaining
        : 0;
    }),
  },

}
</script>

<style lang="scss">
.ui-dropdown {
  // transition
  transition: all .2s;
  &-enter,
  &-leave-to {
    opacity: 0;
    transform: translateY(-6px);
  }
  &-enter-to,
  &-leave {
    opacity: 1;
  }

  // styles
  position: absolute;
  top: 0;
  background: #fff;
  border-radius: 4px;
  overflow: hidden;
  box-shadow: 0 8px 40px rgba(51, 51, 51, .16);
  z-index: 50;
  &-content {
    position: relative;
    overflow: hidden;
  }
  &-scrollview {
    max-height: 420px;
    overflow-y: auto;
    overflow-x: hidden;
  }
  &-scrollable {
  }
  &-overlay {
    position: absolute;
    pointer-events: none;
    transition: transform .1s;
    bottom: 0;
    width: 100%;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, $white 100%);
  }
  &-footer {
    button {
      border-radius: 0;
    }
  }

  // Position
  &-left {
    left: 0;
  }

  // Position
  &-right {
    right: 0;
  }
}
</style>
